export default __webpack_public_path__ + "static/media/misc-closetC-1920w.b6c27a1e.avif";